// @flow

import * as React from 'react';

import classnames from '@ta/common.classnames';

import styles from './AbbreviatedTitle.less';

type Props = {|
  title: string,
  className?: string,
|};

const AbbreviatedTitle = ({ title, className }: Props) => (
  <>
    <span className={classnames(styles.title, className)}>{title}</span>
  </>
);

export default AbbreviatedTitle;
